import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type GroupWithCountData } from '../services/groupListWithCountService'

export interface AssetGroupWithCountState {
  isLoading: boolean
  error: string | undefined
  groupListData: GroupWithCountData[] | undefined
  httpStatus: number | undefined
}

export const initialState: AssetGroupWithCountState = {
  isLoading: true,
  error: undefined,
  groupListData: undefined,
  httpStatus: 0
}

const allGroupsWithCountSlice = createSlice({
  name: 'allGroupsWithCount',
  initialState,
  reducers: {
    allGroupDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        groupListData: undefined,
        httpStatus: 0
      }
    },
    allGroupDataUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        groupListData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    allGroupDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        groupListData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  allGroupDataLoadingAction,
  allGroupDataUpdateAction,
  allGroupDataErrorAction
} = allGroupsWithCountSlice.actions

export default allGroupsWithCountSlice.reducer
